export default "__VITE_ASSET__ec14cfc5__"